<template>
<div>
    <page-head :title="title" :btn-list="btnList" @handleBtn="handleBtn"></page-head>
    <div class="content">
        <div class="search">
            <Form>
                <row :gutter="80">
                    <i-col span="8">
                        <FormItem label="不动产单元号">
                            <div class="detail">{{payInfo.estateUnitNO}}</div>
                        </FormItem>
                    </i-col>
                    <i-col span="8">
                        <FormItem label="缴费人">
                            <div class="detail">{{payInfo.userList && payInfo.userList[0] && payInfo.userList[0].userName}}</div>
                        </FormItem>
                    </i-col>
                    <i-col span="8">
                        <FormItem label="证件号码">
                            <div class="detail">{{payInfo.userList && payInfo.userList[0] && payInfo.userList[0].idCardNO}}</div>
                        </FormItem>
                    </i-col>
                    <i-col span="8">
                        <FormItem label="土地使用起始时间">
                            <div class="detail">{{payInfo.tdsyqssj}}</div>
                        </FormItem>
                    </i-col>
                    <i-col span="8">
                        <FormItem label="土地使用结束时间">
                            <div class="detail">{{payInfo.tdsyjssj}}</div>
                        </FormItem>
                    </i-col>
                    <i-col span="8">
                        <FormItem label="采集人">
                            <div class="detail">{{payInfo.createUserName }}</div>
                        </FormItem>
                    </i-col>
                    <i-col span="8">
                        <FormItem label="采集时间">
                            <div class="detail">{{payInfo.createTime }}</div>
                        </FormItem>
                    </i-col>
                    <i-col span="8">
                        <FormItem label="审核人">
                            <div class="detail">{{payInfo.checkUserName}}</div>
                        </FormItem>
                    </i-col>
                    <i-col span="8">
                        <FormItem label="审核时间">
                            <div class="detail">{{payInfo.checkTime && payInfo.checkTime.substr(0,19)}}</div>
                        </FormItem>
                    </i-col>
                    <i-col span="8">
                        <FormItem label="审核状态">
                            <div class="detail">{{payInfo.checkStatus!=null?typeList[payInfo.checkStatus].type:''}}</div>
                        </FormItem>
                    </i-col>
                    <i-col span="16">
                        <FormItem label="凭证" prop="headPicUrl">
                              <img v-for="(item, index) in imgArr" :key="index" class="headPicUrl" :src="item ||require('@/assets/images/default_avatar.jpg')" @click.stop="clickPic(item)" />
                        </FormItem>
                    </i-col>
                    <preview-img :currentIndex="0" :imgArr="showPreview.list" v-if="showPreview.show" v-on:closePreview="closePreview"></preview-img>
                    <Modal @on-visible-change="onVisibleChange" :value="showCheckMsg" :title="modalTitle">
                        <Input type="textarea" v-model="checkMsg" :rows="10" placeholder="请输入..." />
                        <div slot="footer">
                            <Button style="margin-right:10px" @click="showCheckMsg = false">取消</Button>
                            <Button type="primary" @click="review" :loading="isBtbLoading">确定</Button>
                        </div>
                    </Modal>
                </row>
            </Form>
        </div>
        <div class="table-data" v-if="estateInfo">
            <div class="verifyRecord">房屋信息</div>
            <Form>
                <row :gutter="80">
                    <i-col span="8">
                        <FormItem label="产权证号">
                            <div class="detail">{{estateInfo.estateNO}}</div>
                        </FormItem>
                    </i-col>
                    <i-col span="8">
                        <FormItem label="房屋所有权人">
                            <div class="detail">{{estateInfo.estateOwner}}</div>
                        </FormItem>
                    </i-col>
                    <i-col span="8">
                        <FormItem label="共有情况">
                            <div class="detail">{{estateInfo.possession}}</div>
                        </FormItem>
                    </i-col>
                    <i-col span="8">
                        <FormItem label="房屋坐落">
                            <div class="detail">{{estateInfo.address}}</div>
                        </FormItem>
                    </i-col>
                    <i-col span="8">
                        <FormItem label="建筑年代">
                            <div class="detail">{{estateInfo.buildTime}}</div>
                        </FormItem>
                    </i-col>
                    <i-col span="8">
                        <FormItem label="房屋性质">
                            <div class="detail">{{estateInfo.houseProperty}}</div>
                        </FormItem>
                    </i-col>
                    <i-col span="8">
                        <FormItem label="规划用途">
                            <div class="detail">{{estateInfo.planningUse}}</div>
                        </FormItem>
                    </i-col>
                    <i-col span="8">
                        <FormItem label="总层数">
                            <div class="detail">{{estateInfo.totalFloor}}</div>
                        </FormItem>
                    </i-col>
                    <i-col span="8">
                        <FormItem label="规划面积">
                            <div class="detail">{{estateInfo.planningArea}} 平方米</div>
                        </FormItem>
                    </i-col>
                    <i-col span="8">
                        <FormItem label="限制状态">
                            <div class="detail">{{estateInfo.limitState}}</div>
                        </FormItem>
                    </i-col>
                </row>
            </Form>
        </div>
    </div>
</div>
</template>

<script>
import pageHead from "../../../../components/head";
import PreviewImg from "../../../../components/previewImg";
import api from "../../../../api/index";
const {
    dataColectDetail,
    batchCheckLandTransfer
} = api;
const TYPEMAP = {
    0: {
        checkStatus: "审核未通过"
    },
    1: {
        checkStatus: "审核已通过"
    },
    2: {
        checkStatus: "待审核"
    }
};
export default {
    name: "landTransferDetail",
    components: {
        pageHead,
        PreviewImg
    },
    data() {
        return {
            title: "土地出让金缴费采集详情",
            checkMsg: "",
            checkedId: "",
            showCheckMsg: false,
            isBtbLoading: false,
            pageNum: 1,
            modalTitle: "",
            payInfo: {},
            estateInfo: {},
            btnList: [{
                    name: "审核通过",
                    type: "checkPass"
                },
                {
                    name: "审核不通过",
                    type: "checkFail"
                }
            ],
            typeList: [{
                    index: 0,
                    type: "未通过"
                },
                {
                    index: 1,
                    type: "已通过"
                },
                {
                    index: 2,
                    type: "待审核"
                }
            ],
            imgArr: [],
            showPreview: {
                show: 0,
                list: []
            } //预览图片
        };
    },
    methods: {
        async getDetail() {
            try {
                let {
                    estateCollectionId
                } = this.$route.query;
                let res = await this.$get(dataColectDetail(estateCollectionId));
                console.log(res);
                if (res.isSucceed && res.rows) {
                    this.payInfo = res.rows[0].payInfo;
                    this.imgArr = this.payInfo.picUrl && this.payInfo.picUrl.split(",");
                    this.estateInfo = res.rows[0].estateInfo;
                }
            } finally {}
        },
        clickPic(val) {
            this.showPreview.list = [];
            console.log(val);
            // this.imgArr.length>0 && this.imgArr.forEach(item=>{
            this.showPreview.list.push({
                isHeight: true,
                path: val
            });
            // })
            console.log(this.showPreview.list);
            this.showPreview.show = 1;
        },
        closePreview() {
            console.log("========closePreview==========");
            this.showPreview.show = 0;
        },
        onVisibleChange(val) {
            if (!val) {
                this.showCheckMsg = false;
                this.checkMsg = "";
            }
        },
        handleBtn(type) {
            if (type == "checkPass") {
                console.log("checkPass");
                this.checkMsg = "审核通过";
                this.modalTitle = "审核通过说明(选填)";
                this.status = 1;
                this.showCheckMsg = true;
            } else if (type == "checkFail") {
                console.log("checkFail");
                this.modalTitle = "审核未通过说明(必填)";
                this.status = 0;
                this.showCheckMsg = true;
            }
        },
        async review() {
            if (!this.checkMsg) {
                return this.$Message.info("请填写审核说明");
            }
            this.isBtbLoading = true;
            try {
                let {
                    estateCollectionId
                } = this.$route.query;
                let ids = [estateCollectionId];
                console.log(ids);
                let res = await this.$post(batchCheckLandTransfer, {
                    checkStatus: this.status,
                    checkMsg: this.checkMsg,
                    ids: ids.join(",")
                });
                this.showCheckMsg = false;
                this.$Message.info("操作成功");
                this.getDetail();
            } finally {
                this.isBtbLoading = false;
                this.checkedId = "";
            }
        }
    },
    created() {
        this.getDetail();
    }
};
</script>

<style lang="less" scoped>
.content {
    margin: 20px;
}

.search {
    width: 100%;
    background-color: white;
    border-radius: 5px;
    padding: 20px;
    margin-bottom: 20px;
}

.detail {
    color: #666;
}

.headPicUrl {
    display: inline-block;
    height: 80px;
    width: 80px;
    margin-right: 20px;
    margin-bottom: 20px;
}

.success {
    color: #ff7b44;
}

.table-data {
    width: 100%;
    background-color: white;
    border-radius: 5px;
    padding: 20px;
    min-height: calc(100vh - 530px);

    .page {
        width: 100%;
        margin-top: 10px;
        display: flex;
        justify-content: center;
    }

    .verifyRecord {
        padding-left: 10px;
        margin-bottom: 20px;
        border-left: 3px solid #ff794e;
        height: 16px;
        line-height: 16px;
    }
}
</style>
